/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataSourceTypeDefinitionDto } from '../../models/data-source-type-definition-dto';

export interface DatasourceTypesTypeDefinitionIdGet$Plain$Params {
  typeDefinitionId: string;
}

export function datasourceTypesTypeDefinitionIdGet$Plain(http: HttpClient, rootUrl: string, params: DatasourceTypesTypeDefinitionIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DataSourceTypeDefinitionDto>> {
  const rb = new RequestBuilder(rootUrl, datasourceTypesTypeDefinitionIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('typeDefinitionId', params.typeDefinitionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataSourceTypeDefinitionDto>;
    })
  );
}

datasourceTypesTypeDefinitionIdGet$Plain.PATH = '/datasource-types/{typeDefinitionId}';
